import { create } from 'zustand';
import { listProjects } from '../api/projects.js';
import { listQuotes } from '../api/quotes.js';
import { listApuIaRuns } from '../api/apuIa.js';

type DemoNavState = {
  loading: boolean;
  projectId: string | null;
  quoteId: string | null;
  apuRunId: string | null;
  ensureLoaded: () => Promise<void>;
};

/**
 * IDs del proyecto ejemplo para que los pills del header naveguen de verdad.
 */
export const useDemoNavStore = create<DemoNavState>((set, get) => ({
  loading: false,
  projectId: null,
  quoteId: null,
  apuRunId: null,

  ensureLoaded: async () => {
    const cur = get();
    // Reintentar si falta quote/run (p. ej. primera carga falló por carrera de auth).
    if (cur.loading) return;
    if (cur.projectId && cur.quoteId && cur.apuRunId) return;
    set({ loading: true });
    try {
      const projects = await listProjects();
      const example = projects.find((p) => p.isExample) ?? projects[0];
      if (!example) {
        set({ loading: false });
        return;
      }
      let quoteId = example.latestQuoteId ?? cur.quoteId ?? null;
      let apuRunId: string | null = cur.apuRunId;
      if (!quoteId) {
        try {
          const qs = await listQuotes(example.id);
          quoteId = qs[0]?.id ?? null;
        } catch {
          /* ignore */
        }
      }
      if (quoteId && !apuRunId) {
        try {
          const { runs } = await listApuIaRuns(quoteId);
          apuRunId = runs[0]?.id ?? null;
        } catch {
          /* ignore */
        }
      }
      set({
        projectId: example.id,
        quoteId,
        apuRunId,
        loading: false,
      });
    } catch {
      set({ loading: false });
    }
  },
}));
